import {api} from '../../contexts/AuthContext';
import {EskimiAdvertiser} from '../../types';

// Advertisers API
export const advertisersApi = {
    search: async (searchTerm: string, limit: number = 20): Promise<EskimiAdvertiser[]> => {
        const response = await api.get('/api/advertisers/search', {
            params: {search: searchTerm, limit}
        });
        return response.data;
    },

    getAll: async (limit: number = 100, offset: number = 0): Promise<EskimiAdvertiser[]> => {
        const response = await api.get('/api/advertisers', {
            params: {limit, offset}
        });
        return response.data;
    },

    getById: async (id: number): Promise<EskimiAdvertiser> => {
        const response = await api.get(`/api/advertisers/${id}`);
        return response.data;
    }
};
